const locations = [{
    "key":"sd",
    "label":"San Diego",
    "lat":32.72,
    "lng":-117.15,
    "zoom":11
},{
    "key":"la",
    "label":"Los Angeles",
    "lat":34.04,
    "lng":-118.31,
    "zoom":11
},{
    "key":"sf",
    "label":"San Francisco",
    "lat":37.77,
    "lng":-122.40,
    "zoom":11
},{
    "key":"ny",
    "label":"New York",
    "lat":40.74,
    "lng":-74.0,
    "zoom":11
},{
    "key":"dc",
    "label":"Washington, DC",
    "lat":38.88,
    "lng":-77.04,
    "zoom":11
},{
    "key":"bs",
    "label":"Boston",
    "lat":42.36,
    "lng":-71.05,
    "zoom":11
},{
    "key":"br",
    "label":"Berlin",
    "lat":52.51,
    "lng":13.36,
    "zoom":11
},{
    "key":"tk",
    "label":"Tokyo",
    "lat":35.69,
    "lng":139.73,
    "zoom":11
}]

export default {
	locations,
}